module.exports = __webpack_public_path__ + "img/meat_goldenfarmtk.ec4255a.png";